import React from 'react';

import {
  LATEST_THEME_STYLESHEET_VERSION
} from 'themes_const_shared/theme_stylesheet_versions.js';

import {
  LoadingNoSpinIcon,
  CheckCircleOpenIcon
} from 'zoomforth_component_lib/app_modern_icons.jsx';

import { get as getAccount } from 'zoomforth_zf/appglobals/account.js';

const ThemeStyleSheetStatus = ({ theme })=> (
  (
    // temporary setting so users don't understand the concept of
    // upgrades until we are working on their account to upgrade
    // things.
    !getAccount().get('is_enabled_accessibility') ||
    theme.stylesheet_version === LATEST_THEME_STYLESHEET_VERSION
  ) ?
    <span className="latest-version">
      <CheckCircleOpenIcon /> Latest version
    </span>
  :
    <span className="upgrade-available">
      <LoadingNoSpinIcon /> Upgrade available
    </span>
);

export default ThemeStyleSheetStatus;
